import { ContactType } from '../../contacts/types/contactType'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { ZervantContactType } from '../enums/zervantContactType'
import { isDocumentTypeInvoice } from './isDocumentTypeInvoice'

export const isDocumentEligibleForXRechnung = (
  documentType: InvoiceDocumentType,
  contactCountry?: string | null,
  contactType?: ZervantContactType | ContactType,
): boolean => {
  const isCompanyContact = contactType === ZervantContactType.Company || contactType === ContactType.Company
  return contactCountry === 'DE' && isCompanyContact && isDocumentTypeInvoice(documentType)
}
